<template>
  <div class="exhibitionManageBox">
    <vab-query-form class="ml-10" style="padding-top: 20px">
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="state.queryForm" @submit.prevent>
          <el-form-item label="应用名称">
            <el-input v-model="state.queryForm.meetingName" class="mr-10" clearable placeholder="请输入应用名称" />
          </el-form-item>

          <el-form-item label="应用状态">
            <el-select
              v-model="state.queryForm.isShelf"
              class="m-2"
              placeholder="请选择应用状态"
              @change="handleQueryData"
            >
              <el-option v-for="item in state.typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="应用类型">
            <el-select v-model="state.queryForm.aiApplicationType" clearable @change="handleQueryData">
              <el-option v-for="item in state.appTypeList" :key="item.type" :label="item.name" :value="item.type" />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button icon="Search" type="primary" @click="handleQueryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>

    <el-row :gutter="10">
      <el-col v-for="(item, index) in state.list" :key="index" :lg="8" :md="24" :sm="24" :xl="6" :xs="24">
        <div class="box-card">
          <div class="title">
            <div class="name">{{ item.meetingName }}</div>
            <el-icon v-if="hasPermission(['exhibition:edit'])" class="editIcon" @click="handleEdit(item)">
              <Edit />
            </el-icon>
          </div>
          <div class="form">
            <div class="form-item">
              <div class="label">应用状态</div>
              <div class="item">
                <div v-if="item.isShelf == true" class="yishangjia iconbox">已上架</div>
                <div v-else class="yixiajia iconbox">已下架</div>
              </div>
            </div>
            <div class="form-item">
              <div class="label">应用类型</div>
              <div class="item">
                {{ getAppType(item.aiApplicationType) }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">应用时间</div>
              <div class="item">
                {{ item.listTime ? item.listTime : '暂无' }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">创建人姓名</div>
              <div class="item">
                {{ item.hostName ? item.hostName : '暂无' }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">创建人手机号</div>
              <div class="item">
                {{ item.hostPhone || item.phone || '暂无' }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">应用Code</div>
              <div class="item">
                {{ item.code }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">备注</div>
              <div class="item">
                {{ item.exRemark }}
              </div>
            </div>
          </div>
          <div class="controllBox">
            <el-button type="primary" @click="goAppManage(item)">进入管理</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      v-if="state.total > 9"
      background
      :current-page="state.queryForm.pageNum"
      :layout="state.layout"
      :page-size="state.queryForm.pageSize"
      :total="state.total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <!-- 编辑 -->
    <edit-com ref="refExDialog" @noticeRefresh="getData" />
  </div>
</template>
<script>
  export default {
    name: 'ExhibitionManage',
  }
</script>
<script setup>
  import { onActivated, reactive, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useComponent } from './components/index'
  import { Edit } from '@element-plus/icons'
  import { exShelfAndUnshelfList, appConfigGetlist } from '@/api/exhibitionManage'
  import { debounce } from '@/utils/debounce'

  import { hasPermission } from '@/utils/permission'
  // 引入组件
  const { editCom } = useComponent()
  const router = useRouter()
  const refExDialog = ref(null) // 编辑弹框
  const loading = ref(false) // 列表动画加载

  const state = reactive({
    queryForm: {
      isShelf: '',
      meetingName: '',
      pageNum: 1,
      pageSize: 12,
      status: '',
      aiApplicationType: '',
    },
    collapseItem: 0,
    total: 0,
    layout: 'prev, pager, next',
    list: [],
    typeOptions: [
      {
        label: '全部',
        value: '',
      },
      {
        label: '上架中',
        value: 'true',
      },
      {
        label: '已下架',
        value: 'false',
      },
    ],
    appTypeList: [
      {
        label: '全部',
        value: '',
      },
    ],
  })

  const getAppType = (type) => {
    const matched = state.appTypeList?.filter((v) => v.type === type)
    return matched && matched.length ? matched[0].name : ''
  }

  const getData = async () => {
    loading.value = true
    const { data } = await exShelfAndUnshelfList(state.queryForm)
    const { data: typeList } = await appConfigGetlist()
    state.list = data.data
    state.total = data.total || 0
    setTimeout(() => {
      loading.value = false
    }, 500)
    let arr = [
      {
        name: '全部',
        type: '',
      },
    ]
    arr = [...arr, ...typeList]
    state.appTypeList = arr
  }

  // 进入应用管理中间页
  const goAppManage = (row) => {
    router.push({
      path: '/exhibitionManage/appManage',
      query: {
        meetingCode: row.code,
        aiApplicationType: row.aiApplicationType,
        meetingName: row.meetingName,
        pageId: row.pageId,
        logo: row.logo,
        enterpriseCode: row.enterpriseCode,
      },
    })
  }

  // 查询
  const handleQueryData = debounce(() => {
    state.queryForm.pageNum = 1
    state.collapseItem = 0
    getData()
  })

  // 编辑
  const handleEdit = (row) => {
    refExDialog.value.handleOpen({ ...row })
  }
  // 条数
  const handleSizeChange = debounce((pageSize) => {
    state.queryForm.pageSize = pageSize
    state.collapseItem = 0
    getData()
  })

  // 页码
  const handleCurrentChange = debounce((pageNum) => {
    state.queryForm.pageNum = pageNum
    state.collapseItem = 0
    getData()
  })

  // 挂载
  onActivated(async () => {
    getData()
  })
</script>

<style lang="scss" scoped>
  .exhibitionManageBox {
    background: #f5f5f5;
    height: 80vh;
  }

  .collapseTitle {
    font-size: 16px;
  }

  .el-descriptions__label {
    font-size: 14px;
  }

  .box-card {
    cursor: pointer;
    min-height: 253px;
    background: #fff;
    border-radius: 12px;
    padding: 0 12px 20px 12px;
    margin-bottom: 10px;

    // max-width: 500px;
    .title {
      height: 45px;
      line-height: 45px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      justify-content: space-between;

      .editIcon {
        font-size: 20px;
        line-height: 55px;
        color: #409eff;
      }

      .name {
        width: calc(100% - 30px);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
    }

    .form {
      padding: 10px 0;
      border-bottom: 1px solid #f5f5f5;

      .form-item {
        display: flex;
        margin-top: 8px;

        .label {
          width: 30%;
          font-size: 12px;
          font-weight: 400;
          color: #909499;
        }

        .item {
          .iconbox {
            font-size: 10px;
            font-weight: 400;
          }

          .yishangjia {
            width: 60px;
            height: 17px;
            line-height: 17px;
            background: #e7faf0;
            border-radius: 2px;
            border: 1px solid #d0f5e0;
            color: #21cf6b;
            position: relative;
            padding-left: 13px;

            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: 6px;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background: #21cf6b;
              border-radius: 50%;
            }
          }

          .yixiajia {
            width: 60px;
            height: 17px;
            line-height: 17px;
            background: #feeded;
            border-radius: 2px;
            border: 1px solid #ffdbdd;
            color: #ff5153;
            position: relative;
            padding-left: 13px;

            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: 6px;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background: #ff5153;
              border-radius: 50%;
            }
          }
        }
      }
    }

    .controllBox {
      display: flex;
      justify-content: right;
      align-items: center;
      margin-top: 10px;
    }
  }

  .card-header {
    display: flex;
    justify-content: space-between;
  }
</style>
